import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'

import { fetchGroups, createGroup, editGroup } from '../../actions/products_actions'

import GroupForm from '../../components/Products/groupForm';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  if (values.IsEnabled === null ) {
      errors.IsEnabled = 'Required'
  }
  return errors
}


let groupForm = reduxForm({
    form: 'groupForm',
    validate
})(GroupForm);

function mapStateToProps(state) {
    return {
        currentGroup: state.products.currentGroup,
        initialValues: state.products.currentGroup,
        isCreating: state.products.groupIsCreating,
        createError: state.products.groupCreateError,
        created: state.products.groupCreated,
        isEditing: state.products.groupIsEditing,
        editError: state.products.groupEditError,
        edited: state.products.groupEdited,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { fetchGroups, createGroup, editGroup })(groupForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/groupForm.jsx